import { createSlice } from "@reduxjs/toolkit";

const userDatasSlice = createSlice({
	name: "userDatas",
	initialState: {
		_id: null,
		name: null,
		email: null,
		phone: null,
		role: null,
		suspend: null,
	},
	reducers: {
		setUserDatas: (state, action) => {
			if (!action.payload) return state;
			const { _id, name, email, phone, role, suspend } = action.payload;
			return { _id, name, email, phone, role, suspend };
		},
	},
});

export const { setUserDatas } = userDatasSlice.actions;
export default userDatasSlice.reducer;
